const getters = {
    sidebar: state => state.app.sidebar,
    size: state => state.app.size,
    device: state => state.app.device,
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
    token: state => state.user.token,
    name: state => state.user.name,
    user_id: state => state.user.id,
    mobile: state => state.user.mobile,
    email: state => state.user.email,
    is_bind_wx: state => state.user.is_bind_wx,
    team_name: state => state.user.team_name,
    introduction: state => state.user.introduction,
    roles: state => state.user.roles,
    permission_routes: state => state.permission.routes,
    confirm_route:state => state.app.confirmRoute,
    is_admin:state => state.user.is_admin||state.user.super_admin,
    is_super_admin:state => state.user.super_admin,
    show_queue_modal:state => state.workOrder.showQueueModal,
    isBindWx:(state)=>{
        return state.isBindWx;
    },
    umc_token:state => state.user.umc_token,
    // isAdmin(state){
    //     let userName = state.user.username||'';
    //     let adminInfo = state.organizationInfo.admin||{};
    //     let adminName = adminInfo.username||'';
    //     return userName.length>0&&userName===adminName;
    // },
    is_sub_account:(state)=>{
        return state.user.is_sub_account;
    },
    checked_media_account:(state)=>{
        return state.mediaAccount.checkedAccountList;
    },
    tabs_map:(state)=>{
        return state.permission.tabsMap;
    },
    apple_notify:(state)=>{
        return state.apple.apple_notify;
    },
    apple_time_zone:(state)=>{
        return state.apple.time_zone;
    },
    apple_common_config:(state)=>{
        return state.apple.common_config;
    },
    apple_edit_info:(state)=>{
        return state.apple.editInfo;
    },
    apple_create_type:(state)=>{
        return state.apple.create_type;
    },
    apple_reload:(state)=>{
        return state.apple.is_reload_list;
    },
    submit_url_name:(state)=>{
        return state.apple.submit_url_name;
    },
    cur_tab_page:(state)=>{
        return state.apple.cur_tab_page;
    },
    apple_list_page_query:(state)=>{
        return state.apple.list_page_query;
    },
    daily_task_period_config:(state)=>{
        return state.dailyTask.period_config;
    },
};
export default getters
